import {useTranslation} from 'react-i18next'

import {LinkButton} from '@sdox/ui'
import {IconLocation, IconMail, IconMobile, IconPhone} from '@sdox/icons'
import {useCurrentContactPerson, useCurrentOffice} from '@sdox/api'

import {GoogleMapsButton} from './GoogleMapsButton'

export const ContactInfoButtons = () => {
  const {t} = useTranslation()
  const office = useCurrentOffice()
  const contactPerson = useCurrentContactPerson()
  const {email, phone, displayEmail, mobile} = contactPerson ?? {}
  const shownEmail = displayEmail || email

  return (
    <div className={'flex justify-center gap-spacing-12 py-spacing-16 md:hidden'}>
      {shownEmail ? (
        <LinkButton
          href={`mailto:${shownEmail}`}
          leading={<IconMail />}
          variant={'outline'}
          size={'medium'}
          aria-label={t('common:openInMail')}
          title={t('common:openInMail')}
        />
      ) : null}
      {phone ? (
        <LinkButton
          href={`tel:${phone}`}
          leading={<IconPhone />}
          variant={'outline'}
          size={'medium'}
          aria-label={t('common:call')}
          title={t('common:call')}
        />
      ) : null}
      {mobile ? (
        <LinkButton
          href={`tel:${mobile}`}
          leading={<IconMobile />}
          variant={'outline'}
          size={'medium'}
          aria-label={t('common:call')}
          title={t('common:call')}
        />
      ) : null}
      {office?.googleMapsUrl ? (
        <GoogleMapsButton
          size={'medium'}
          variant={'outline'}
          href={office?.googleMapsUrl}
          leading={<IconLocation />}
        />
      ) : null}
    </div>
  )
}
